import React from 'react';
import { Select, SelectProps } from 'antd';
import { LabeledValue, RefSelectProps } from 'antd/lib/select';

export type USStateSelectProps = SelectProps<string> & {
  readOnly?: boolean;
};

const USStateSelect = React.forwardRef<RefSelectProps, USStateSelectProps>(({ readOnly, value, ...props }, ref) => {
  return readOnly ? (
    <div className={props.className}>{value}</div>
  ) : (
    <Select<string>
      {...props}
      ref={ref}
      showSearch
      allowClear
      options={getOptions()}
      optionFilterProp="label"
      filterOption={(input, option) => {
        // @ts-ignore
        return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      value={value ? value : undefined}
    />
  );
});

const getOptions = (): LabeledValue[] => {
  return US_STATES.map(toOption);
};

const toOption = (state: string): LabeledValue => {
  return {
    label: state,
    key: state,
    value: state,
  };
};

const US_STATES = [
  'AZ',
  'AR',
  'CA',
  'CZ',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export default USStateSelect;
